export const REQUEST_MASTER_HOME = "REQUEST_MASTER_HOME";
export const SET_MASTER_HOME = "SET_MASTER_HOME";
export const ERROR_GET_MASTER_HOME = "ERROR_GET_MASTER_HOME";

export const REQUEST_CREATE_MASTER_HOME = "REQUEST_CREATE_MASTER_HOME";
export const SUCCESS_CREATE_MASTER_HOME = "SUCCESS_CREATE_MASTER_HOME";
export const ERROR_CREATE_MASTER_HOME = "ERROR_CREATE_MASTER_HOME";

export const REQUEST_UPDATE_MASTER_HOME = "REQUEST_UPDATE_MASTER_HOME";
export const SUCCESS_UPDATE_MASTER_HOME = "SUCCESS_UPDATE_MASTER_HOME";
export const ERROR_UPDATE_MASTER_HOME = "ERROR_UPDATE_MASTER_HOME";

export const REQUEST_DELETE_MASTER_HOME = "REQUEST_DELETE_MASTER_HOME";
export const SUCCESS_DELETE_MASTER_HOME = "SUCCESS_DELETE_MASTER_HOME";
export const ERROR_DELETE_MASTER_HOME = "ERROR_DELETE_MASTER_HOME";

export const SET_MESSAGE_MASTER_HOME = "SET_MESSAGE_MASTER_HOME";
